// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"hC","winCardBox":"hC","win-card-btn-detail":"hD","winCardBtnDetail":"hD","win-card-dec":"hE","winCardDec":"hE","win-card-name":"hF","winCardName":"hF"};